// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-list-container .listing-header {
  display: flex;
  justify-content: space-between;
  padding: 0.3125rem 0 1.5625rem 0;
}
.products-list-container .listing-header .title-div {
  font: normal normal bold 1.75rem/28px Noto Sans;
  color: var(--ion-color-primary-black);
  text-transform: capitalize;
}
.products-list-container .listing-header .search-and-filter {
  display: flex;
  justify-content: flex-end;
}
.products-list-container .listing-header .search-and-filter .filter-div {
  display: flex;
}
.products-list-container .listing-header .search-and-filter .filter-div .filter-icon {
  display: flex;
  align-items: center;
  padding: 0 0.5625rem;
  cursor: pointer;
}
.products-list-container .listing-header .search-and-filter .filter-div .filter-label {
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.0625rem;
  display: flex;
  align-items: center;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.products-list-container .listing-header .search-and-filter .filter-div .close-label {
  color: var(--ion-color-primary-black) !important;
}
.products-list-container .listing-table {
  padding: 0 0 1.25rem;
  overflow-x: auto;
}
.products-list-container .listing-table .table {
  width: 100%;
}
.products-list-container .listing-table .table .column-heading {
  font-weight: 400;
  font-size: 0.975rem;
  line-height: 1rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
  padding: 0.75rem 0.5625rem 0.75rem 0;
  cursor: pointer;
}
.products-list-container .listing-table .table .status-col {
  min-width: 150px;
  max-width: 150px;
  width: 150px;
  cursor: default !important;
}
.products-list-container .listing-table .table .ship-to-col {
  min-width: 100px;
  max-width: 244px;
}
.products-list-container .listing-table .table .product-id {
  font: normal normal bold 1rem/24px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  margin-left: 0.375rem;
}
.products-list-container .listing-table .table .table-body {
  font: normal normal normal 1rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}
.products-list-container .listing-table .table .table-body .table-row {
  border-bottom: 1px solid var(--ion-color-primary-border);
}
.products-list-container .listing-table .table .table-body .table-row td {
  padding: 0.4375rem 0.5625rem 0.1875rem 0;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--ion-color-primary-black);
}
.products-list-container .listing-table .table .table-body .table-row .right-arrow {
  display: flex;
  align-items: center;
}
.products-list-container .mobile-view-listing .order-container .order-card {
  background: var(--ion-color-primary-white);
  border: 1px solid var(--ion-color-primary-border);
  border-radius: 2px;
  margin: 0.625rem 0;
}
.products-list-container .mobile-view-listing .order-container .order-card .order-card-col {
  padding-top: 0.9375rem;
}
.products-list-container .mobile-view-listing .order-container .order-card .grid-label {
  font-weight: 400;
  font-size: 0.6875rem;
  line-height: 0.8125rem;
  text-transform: uppercase;
  color: var(--ion-color-secondary-black);
}
.products-list-container .mobile-view-listing .order-container .order-card .grid-values {
  padding-top: 0.1875rem;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.1875rem;
  color: var(--ion-color-secondary-blue);
}
.products-list-container .mobile-view-listing .order-container .mobile-right-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-btn,
.pending,
.shipped,
.canceled {
  font-weight: 400;
  font-size: 0.8375rem;
  line-height: 1.125rem;
  border-radius: 4px;
  width: 100px;
  height: 2.125rem;
  text-transform: unset;
}

.pending {
  background: rgba(109, 207, 246, 0.2);
  color: var(--ion-color-primary-blue);
}

.shipped {
  background: rgba(172, 219, 97, 0.25);
  color: var(--ion-color-green-100);
}

.canceled {
  background: rgba(233, 75, 75, 0.1);
  color: var(--ion-color-primary);
}

.shipping,
.partially-shipped {
  background: rgba(255, 121, 23, 0.17);
  color: var(--ion-color-primary-orange);
}

.order-card .status-btn {
  width: auto;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 0.875rem;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}

.mass-upload-btn {
  width: 171px;
  height: 46px;
  background: var(--ion-color-primary) 0% 0% no-repeat padding-box;
  opacity: 1;
  font: normal normal bold 0.9375rem/1.25rem Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-white);
  text-transform: uppercase;
  opacity: 1;
}

.products-number-div {
  font: normal normal bold 0.875rem/27px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
  font-size: 0.875rem;
}

.id-col {
  min-width: 90px;
}

.img-col {
  min-width: 110px;
}

.name-col {
  min-width: 160px;
}

.description-col {
  min-width: 190px;
}

.discount-type-col {
  min-width: 140px;
}

.discount-col {
  min-width: 120px;
}

.created-at-col {
  min-width: 160px;
}

.discount-timeline-col {
  min-width: 180px;
}

.region-col {
  min-width: 140px;
}

.edit-col {
  min-width: 60px;
}

.edit-img-icon {
  cursor: pointer;
}

.product-checkbox {
  --opacity: 1;
  --border-color: var(--ion-color-primary-border);
  --border-width: 1px;
}

.thead {
  border-bottom: 1px solid var(--ion-color-primary-border);
  font: normal normal medium 0.75rem/14px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-secondary-black);
  text-transform: uppercase;
  opacity: 1;
}

.pagination-wrapper {
  max-width: 1400px;
  margin: auto;
  text-align: center;
}

.pagination-div {
  align-items: center;
}

.pagination-grid {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 1.25rem 0;
}
.pagination-grid-tile {
  width: 33%;
  padding: 0;
}

.perpage-dropdown {
  display: flex;
  align-items: center;
}
.perpage-dropdown ion-item {
  font: normal normal 600 0.875rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.perpage-title {
  font: normal normal normal 0.875rem/21px Noto Sans;
  letter-spacing: 0;
  color: var(--ion-color-primary-black);
  opacity: 1;
}

.pagination-col {
  text-align: left;
}

.search-div {
  margin-right: 0.625rem;
  align-self: center;
}
.search-div input {
  border: 1px solid var(--ion-color-primary-border);
  font-size: 0.75rem;
  padding: 0.1875rem 0.625rem;
  border-radius: 0;
}

.status-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mw-150 {
  min-width: 150px;
}

.filter-section {
  flex-wrap: wrap;
  justify-content: unset !important;
}

.order-ng-select-container {
  display: flex;
  column-gap: 0.625rem;
  align-items: center;
  margin-right: 1.25rem;
}

.status-select-input {
  width: 100%;
}

.from-date-div,
.to-date-div {
  width: unset;
  margin-bottom: 0.9375rem;
}

.from-date-class,
.to-date-class {
  max-width: 190px;
}

.filter-buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  column-gap: 0.625rem;
  row-gap: 0.625rem;
}

.to-date-class {
  margin-top: 2rem;
}

.status-container {
  column-gap: 20px;
}

.status-label {
  width: 100%;
  padding-bottom: 0.625rem;
  font-weight: bold;
  text-transform: capitalize !important;
  color: var(--ion-color-primary-black);
}

@media (max-width: 767px) {
  .product-search-div ion-item {
    width: 100%;
  }
  .from-date-class,
  .to-date-class,
  .status-select-input {
    max-width: 100%;
    width: 100%;
  }
  .products-list-container .listing-header {
    display: block;
  }
  .products-list-container .listing-header .title-div {
    font-size: 1.625rem;
    margin-bottom: 27px;
    line-height: 2rem;
  }
}
.search-icon.RTL {
  align-self: center;
  margin: 0.25rem 0 0 2.625rem;
  cursor: pointer;
}

.search-icon.LTR {
  align-self: center;
  margin: 0.25rem 2.625rem 0 0;
  cursor: pointer;
}

.search-icon {
  align-self: center;
  margin-top: 0.25rem;
  cursor: pointer;
}

.search-div {
  align-self: center;
}
.search-div input {
  border: 1px solid var(--ion-color-primary-border);
  font-size: 0.75rem;
  padding: 0.1875rem 0.625rem;
  border-radius: 0;
}

.search-div {
  align-self: center;
}
.search-div ion-item {
  border: 1px solid var(--ion-color-primary-border);
  font-size: 0.75rem;
  padding: 0.1875rem 0;
  border-radius: 0;
  height: 38px;
  --min-height: 1.25rem;
  width: 271px;
}
.search-div ion-item .sc-ion-input-md-h {
  --padding-top: 0.4375rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-discount-management/product-discount-management.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,8BAAA;EACA,gCAAA;AAFF;AAIE;EACC,+CAAA;EACA,qCAAA;EACA,0BAAA;AAFH;AAKE;EACC,aAAA;EACA,yBAAA;AAHH;AAKG;EACC,aAAA;AAHJ;AAKI;EACC,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;AAHL;AAMI;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,+BAAA;AAJL;AAOI;EACC,gDAAA;AALL;AAWC;EACC,oBAAA;EACA,gBAAA;AATF;AAWE;EACC,WAAA;AATH;AAWG;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,uCAAA;EACA,oCAAA;EACA,eAAA;AATJ;AAYG;EACC,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;AAVJ;AAaG;EACC,gBAAA;EACA,gBAAA;AAXJ;AAcG;EACC,4CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,qBAAA;AAZJ;AAeG;EACC,8CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAbJ;AAeI;EACC,wDAAA;AAbL;AAeK;EACC,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;AAbN;AAgBK;EACC,aAAA;EACA,mBAAA;AAdN;AAwBG;EACC,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,kBAAA;AAtBJ;AAwBI;EACC,sBAAA;AAtBL;AAyBI;EACC,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;AAvBL;AA0BI;EACC,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,sCAAA;AAxBL;AA4BG;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;AA1BJ;;AAiCA;;;;EAIC,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AA9BD;;AAiCA;EACC,oCAAA;EACA,oCAAA;AA9BD;;AAiCA;EACC,oCAAA;EACA,iCAAA;AA9BD;;AAiCA;EACC,kCAAA;EACA,+BAAA;AA9BD;;AAiCA;;EAEC,oCAAA;EACA,sCAAA;AA9BD;;AAkCC;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA/BF;;AAmCA;EACC,yBAAA;AAhCD;;AAmCA;EACC,2BAAA;AAhCD;;AAmCA;EACC,YAAA;EACA,YAAA;EACA,gEAAA;EACA,UAAA;EACA,oDAAA;EACA,iBAAA;EACA,qCAAA;EACA,yBAAA;EACA,UAAA;AAhCD;;AAmCA;EACC,gDAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;EACA,mBAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,gBAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,eAAA;AAhCD;;AAmCA;EACC,YAAA;EACA,+CAAA;EACA,mBAAA;AAhCD;;AAmCA;EACC,wDAAA;EACA,iDAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,UAAA;AAhCD;;AAmCA;EACC,iBAAA;EACA,YAAA;EACA,kBAAA;AAhCD;;AAmCA;EACC,mBAAA;AAhCD;;AAmCA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAhCD;AAkCC;EACC,UAAA;EACA,UAAA;AAhCF;;AAoCA;EACC,aAAA;EACA,mBAAA;AAjCD;AAqCC;EACC,+CAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AAnCF;;AAuCA;EACC,kDAAA;EACA,iBAAA;EACA,qCAAA;EACA,UAAA;AApCD;;AAuCA;EACC,gBAAA;AApCD;;AAuCA;EACC,sBAAA;EACA,kBAAA;AApCD;AAsCC;EACC,iDAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AApCF;;AAyCA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAtCD;;AAyCA;EACC,gBAAA;AAtCD;;AAyCA;EACC,eAAA;EACA,iCAAA;AAtCD;;AAyCA;EACC,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;AAtCD;;AAyCA;EACC,WAAA;AAtCD;;AAyCA;;EAEC,YAAA;EACA,wBAAA;AAtCD;;AAyCA;;EAEC,gBAAA;AAtCD;;AAyCA;EACC,WAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;AAtCD;;AAyCA;EACC,gBAAA;AAtCD;;AAyCA;EACC,gBAAA;AAtCD;;AAyCA;EACC,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,qCAAA;EACA,qCAAA;AAtCD;;AC3NQ;EDqQP;IACC,WAAA;EAtCA;EAyCD;;;IAGC,eAAA;IACA,WAAA;EAvCA;EA0CD;IACC,cAAA;EAxCA;EA0CA;IACC,mBAAA;IACA,mBAAA;IACA,iBAAA;EAxCD;AACF;AA4CA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AA1CD;;AA6CA;EACC,kBAAA;EACA,4BAAA;EACA,eAAA;AA1CD;;AA6CA;EACC,kBAAA;EACA,mBAAA;EACA,eAAA;AA1CD;;AA6CA;EACC,kBAAA;AA1CD;AA4CC;EACC,iDAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AA1CF;;AA8CA;EACC,kBAAA;AA3CD;AA6CC;EACC,iDAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;AA3CF;AA6CE;EACC,wBAAA;AA3CH","sourcesContent":["@import \"src/theme/mixins.scss\";\n\n.products-list-container {\n\t.listing-header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 0.3125rem 0 1.5625rem 0;\n\n\t\t.title-div {\n\t\t\tfont: normal normal bold 1.75rem /28px Noto Sans;\n\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\ttext-transform: capitalize\n\t\t}\n\n\t\t.search-and-filter {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-end;\n\n\t\t\t.filter-div {\n\t\t\t\tdisplay: flex;\n\n\t\t\t\t.filter-icon {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tpadding: 0 0.5625rem;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\n\t\t\t\t.filter-label {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tline-height: 1.0625rem;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tletter-spacing: 0.3px;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t}\n\n\t\t\t\t.close-label {\n\t\t\t\t\tcolor: var(--ion-color-primary-black) !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.listing-table {\n\t\tpadding: 0 0 1.25rem;\n\t\toverflow-x: auto;\n\n\t\t.table {\n\t\t\twidth: 100%;\n\n\t\t\t.column-heading {\n\t\t\t\tfont-weight: 400;\n\t\t\t\tfont-size: 0.975rem;\n\t\t\t\tline-height: 1rem;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\tpadding: 0.75rem 0.5625rem 0.75rem 0;\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\t.status-col {\n\t\t\t\tmin-width: 150px;\n\t\t\t\tmax-width: 150px;\n\t\t\t\twidth: 150px;\n\t\t\t\tcursor: default !important;\n\t\t\t}\n\n\t\t\t.ship-to-col {\n\t\t\t\tmin-width: 100px;\n\t\t\t\tmax-width: 244px;\n\t\t\t}\n\n\t\t\t.product-id {\n\t\t\t\tfont: normal normal bold 1rem /24px Noto Sans;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\t\t\t\tmargin-left: 0.375rem;\n\t\t\t}\n\n\t\t\t.table-body {\n\t\t\t\tfont: normal normal normal 1rem /21px Noto Sans;\n\t\t\t\tletter-spacing: 0;\n\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\topacity: 1;\n\n\t\t\t\t.table-row {\n\t\t\t\t\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\n\t\t\t\t\ttd {\n\t\t\t\t\t\tpadding: 0.4375rem 0.5625rem 0.1875rem 0;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t\tline-height: 1.375rem;\n\t\t\t\t\t\tcolor: var(--ion-color-primary-black);\n\t\t\t\t\t}\n\n\t\t\t\t\t.right-arrow {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t}\n\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.mobile-view-listing {\n\t\t.order-container {\n\t\t\t.order-card {\n\t\t\t\tbackground: var(--ion-color-primary-white);\n\t\t\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\t\t\tborder-radius: 2px;\n\t\t\t\tmargin: 0.625rem 0;\n\n\t\t\t\t.order-card-col {\n\t\t\t\t\tpadding-top: 0.9375rem;\n\t\t\t\t}\n\n\t\t\t\t.grid-label {\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 0.6875rem;\n\t\t\t\t\tline-height: 0.8125rem;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-secondary-black);\n\t\t\t\t}\n\n\t\t\t\t.grid-values {\n\t\t\t\t\tpadding-top: 0.1875rem;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 1.1875rem;\n\t\t\t\t\tcolor: var(--ion-color-secondary-blue);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.mobile-right-arrow {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n.status-btn,\n.pending,\n.shipped,\n.canceled {\n\tfont-weight: 400;\n\tfont-size: 0.8375rem;\n\tline-height: 1.125rem;\n\tborder-radius: 4px;\n\twidth: 100px;\n\theight: 2.125rem;\n\ttext-transform: unset;\n}\n\n.pending {\n\tbackground: rgba(109, 207, 246, 0.2);\n\tcolor: var(--ion-color-primary-blue);\n}\n\n.shipped {\n\tbackground: rgba(172, 219, 97, 0.25);\n\tcolor: var(--ion-color-green-100);\n}\n\n.canceled {\n\tbackground: rgba(233, 75, 75, 0.1);\n\tcolor: var(--ion-color-primary);\n}\n\n.shipping,\n.partially-shipped {\n\tbackground: rgba(255, 121, 23, 0.17);\n\tcolor: var(--ion-color-primary-orange);\n}\n\n.order-card {\n\t.status-btn {\n\t\twidth: auto;\n\t\tfont-weight: 500;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 0.875rem;\n\t}\n}\n\n.justify-end {\n\tjustify-content: flex-end;\n}\n\n.justify-start {\n\tjustify-content: flex-start;\n}\n\n.mass-upload-btn {\n\twidth: 171px;\n\theight: 46px;\n\tbackground: var(--ion-color-primary) 0% 0% no-repeat padding-box;\n\topacity: 1;\n\tfont: normal normal bold 0.9375rem /1.25rem Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-white);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.products-number-div {\n\tfont: normal normal bold 0.875rem /27px Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n\tfont-size: 0.875rem;\n}\n\n.id-col {\n\tmin-width: 90px;\n}\n\n.img-col {\n\tmin-width: 110px;\n}\n\n.name-col {\n\tmin-width: 160px;\n}\n\n.description-col {\n\tmin-width: 190px;\n}\n\n.discount-type-col {\n\tmin-width: 140px;\n}\n\n.discount-col {\n\tmin-width: 120px;\n}\n\n.created-at-col {\n\tmin-width: 160px;\n}\n\n.discount-timeline-col {\n\tmin-width: 180px;\n}\n\n.region-col {\n\tmin-width: 140px;\n}\n\n.edit-col {\n\tmin-width: 60px;\n}\n\n.edit-img-icon {\n\tcursor: pointer;\n}\n\n.product-checkbox {\n\t--opacity: 1;\n\t--border-color: var(--ion-color-primary-border);\n\t--border-width: 1px;\n}\n\n.thead {\n\tborder-bottom: 1px solid var(--ion-color-primary-border);\n\tfont: normal normal medium 0.75rem /14px Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-secondary-black);\n\ttext-transform: uppercase;\n\topacity: 1;\n}\n\n.pagination-wrapper {\n\tmax-width: 1400px;\n\tmargin: auto;\n\ttext-align: center;\n}\n\n.pagination-div {\n\talign-items: center;\n}\n\n.pagination-grid {\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n\tmargin: 1.25rem 0;\n\n\t&-tile {\n\t\twidth: 33%;\n\t\tpadding: 0;\n\t}\n}\n\n.perpage-dropdown {\n\tdisplay: flex;\n\talign-items: center;\n\n\t// position: absolute;\n\t// bottom: 2%;\n\tion-item {\n\t\tfont: normal normal 600 0.875rem /21px Noto Sans;\n\t\tletter-spacing: 0;\n\t\tcolor: var(--ion-color-primary-black);\n\t\topacity: 1;\n\t}\n}\n\n.perpage-title {\n\tfont: normal normal normal 0.875rem /21px Noto Sans;\n\tletter-spacing: 0;\n\tcolor: var(--ion-color-primary-black);\n\topacity: 1;\n}\n\n.pagination-col {\n\ttext-align: left;\n}\n\n.search-div {\n\tmargin-right: 0.625rem;\n\talign-self: center;\n\n\tinput {\n\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\tfont-size: 0.75rem;\n\t\tpadding: 0.1875rem 0.625rem;\n\t\tborder-radius: 0;\n\t}\n}\n\n\n.status-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.mw-150 {\n\tmin-width: 150px;\n}\n\n.filter-section {\n\tflex-wrap: wrap;\n\tjustify-content: unset !important;\n}\n\n.order-ng-select-container {\n\tdisplay: flex;\n\tcolumn-gap: 0.625rem;\n\talign-items: center;\n\tmargin-right: 1.25rem;\n}\n\n.status-select-input {\n\twidth: 100%;\n}\n\n.from-date-div,\n.to-date-div {\n\twidth: unset;\n\tmargin-bottom: 0.9375rem;\n}\n\n.from-date-class,\n.to-date-class {\n\tmax-width: 190px;\n}\n\n.filter-buttons {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tcolumn-gap: 0.625rem;\n\trow-gap: 0.625rem;\n}\n\n.to-date-class {\n\tmargin-top: 2rem;\n}\n\n.status-container {\n\tcolumn-gap: 20px;\n}\n\n.status-label {\n\twidth: 100%;\n\tpadding-bottom: 0.625rem;\n\tfont-weight: bold;\n\ttext-transform: capitalize !important;\n\tcolor: var(--ion-color-primary-black);\n}\n\n@include respond-below(md) {\n\t.product-search-div ion-item {\n\t\twidth: 100%;\n\t}\n\n\t.from-date-class,\n\t.to-date-class,\n\t.status-select-input {\n\t\tmax-width: 100%;\n\t\twidth: 100%;\n\t}\n\n\t.products-list-container .listing-header {\n\t\tdisplay: block;\n\n\t\t.title-div {\n\t\t\tfont-size: 1.625rem;\n\t\t\tmargin-bottom: 27px;\n\t\t\tline-height: 2rem;\n\t\t}\n\t}\n}\n\n.search-icon.RTL {\n\talign-self: center;\n\tmargin: 0.25rem 0 0 2.625rem;\n\tcursor: pointer;\n}\n\n.search-icon.LTR {\n\talign-self: center;\n\tmargin: 0.25rem 2.625rem 0 0;\n\tcursor: pointer;\n}\n\n.search-icon {\n\talign-self: center;\n\tmargin-top: 0.25rem;\n\tcursor: pointer;\n}\n\n.search-div {\n\talign-self: center;\n\n\tinput {\n\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\tfont-size: 0.75rem;\n\t\tpadding: 0.1875rem 0.625rem;\n\t\tborder-radius: 0;\n\t}\n}\n\n.search-div {\n\talign-self: center;\n\n\tion-item {\n\t\tborder: 1px solid var(--ion-color-primary-border);\n\t\tfont-size: 0.75rem;\n\t\tpadding: 0.1875rem 0;\n\t\tborder-radius: 0;\n\t\theight: 38px;\n\t\t--min-height: 1.25rem;\n\t\twidth: 271px;\n\n\t\t.sc-ion-input-md-h {\n\t\t\t--padding-top: 0.4375rem;\n\t\t}\n\t}\n}","// custom fons facemizxin\n\n@mixin font-face($font-family, $url) {\n    @font-face {\n        font-family: '#{$font-family}';\n        src: url('#{$url}.eot');\n        src: url('#{$url}.eot?#iefix') format('embedded-opentype'),\n        url('#{$url}.woff') format('woff'),\n        url('#{$url}.ttf') format('truetype'),\n        url('#{$url}.svg') format('svg');\n        font-weight: normal;\n        font-style: normal;\n    }\n}\n\n\n\n//custom font resposnive muin\n$font-base-min: 14px;\n$font-base-max: 6;\n$breakmin: 320px;\n$breakmax: 768px;\n$customSize: 5px;\n\n@mixin font-responsive($fmin, $fdiff, $breakmin, $breakdiff) {\n    font-size: calc(#{$fmin} + #{$fdiff} * ((100vw - #{$breakmin}) / #{$breakdiff}));\n\n    @media(max-width: $breakmin) {\n        font-size: $fmin;\n    }\n\n    @media(min-width: round($breakmin + $breakmax)) {\n        font-size: round($fmin + $fdiff);\n    }\n\n    @media(max-width: $breakmax) {\n        // font-size: round($fmin + 3px);\n        font-size: calc(#{$fmin} + #{$customSize});\n    }\n}\n\n\n// custom font source mmixins\n\n@mixin font($colour: false, $weight: false, $lh: false, $spacing: false) {\n\n    // @if $size { font-size: $size; }\n    @if $colour {\n        color: $colour;\n    }\n\n    @if $weight {\n        font-weight: $weight;\n    }\n\n    @if $lh {\n        line-height: $lh;\n    }\n\n    @if $spacing {\n        letter-spacing: $spacing;\n    }\n}\n\n\n// custom input placeholder mixins\n\n@mixin input-placeholder {\n    &.placeholder {\n        @content;\n    }\n\n    &:-moz-placeholder {\n        @content;\n    }\n\n    &::-moz-placeholder {\n        @content;\n    }\n\n    &:-ms-input-placeholder {\n        @content;\n    }\n\n    &::-webkit-input-placeholder {\n        @content;\n    }\n}\n\n\n// A map of breakpoints.\n$breakpoints: (\n    xs: 480px,\n    sm: 576px,\n    md: 768px,\n    lg: 992px,\n    xl: 1200px,\n    xxl: 1600px,\n    ipadSize: 768px,\n    ipadmin:481px,\n    ipadmax:1024px,\n    ipadlandscape:1320px,\n\n);\n\n// Respond above.\n@mixin respond-above($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (min-width: $breakpoint-value) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n\n@mixin respond-below($breakpoint) {\n\n    // If the breakpoint exists in the map.\n    @if map-has-key($breakpoints, $breakpoint) {\n\n        // Get the breakpoint value.\n        $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n        // Write the media query.\n        @media (max-width: ($breakpoint-value - 1)) {\n            @content;\n        }\n\n        // If the breakpoint doesn't exist in the map.\n    }\n\n    @else {\n\n        // Log a warning.\n        @warn 'Invalid breakpoint: #{$breakpoint}.';\n    }\n}\n\n\n\n@mixin respond-between($lower, $upper) {\n\n    // If both the lower and upper breakpoints exist in the map.\n    @if map-has-key($breakpoints, $lower) and map-has-key($breakpoints, $upper) {\n\n        // Get the lower and upper breakpoints.\n        $lower-breakpoint: map-get($breakpoints, $lower);\n        $upper-breakpoint: map-get($breakpoints, $upper);\n\n        // Write the media query.\n        @media (min-width: $lower-breakpoint) and (max-width: ($upper-breakpoint - 1)) {\n            @content;\n        }\n\n        // If one or both of the breakpoints don't exist.\n    }\n\n    @else {\n\n        // If lower breakpoint is invalid.\n        @if (map-has-key($breakpoints, $lower)==false) {\n\n            // Log a warning.\n            @warn 'Your lower breakpoint was invalid: #{$lower}.';\n        }\n\n        // If upper breakpoint is invalid.\n        @if (map-has-key($breakpoints, $upper)==false) {\n\n            // Log a warning.\n            @warn 'Your upper breakpoint was invalid: #{$upper}.';\n        }\n    }\n}\n\n\n// @media only screen and (device-width: 768px) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait) {}\n\n// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape) {\n//     /* For landscape layouts only */\n// }\n\n/// vernodr prefixes\n\n@mixin css3-prefix($prop, $value) {\n    -webkit-#{$prop}: #{$value};\n    -moz-#{$prop}: #{$value};\n    -ms-#{$prop}: #{$value};\n    -o-#{$prop}: #{$value};\n    #{$prop}: #{$value};\n}\n\n\n//  vertical cneter\n@mixin vertical-center {\n    position: relative;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n//keyframe miins\n\n@mixin keyframes($name) {\n    @-webkit-keyframes #{$name} {\n        @content;\n    }\n\n    @-moz-keyframes #{$name} {\n        @content;\n    }\n\n    @keyframes #{$name} {\n        @content;\n    }\n}\n\n//absolute positoning\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n\n//arrow minis\n@mixin arrow($direction: down, $size: 5px, $color: #555) {\n    width: 0;\n    height: 0;\n\n    @if ($direction ==left) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-right: $size solid $color;\n    }\n\n    @else if ($direction ==right) {\n        border-top: $size solid transparent;\n        border-bottom: $size solid transparent;\n        border-left: $size solid $color;\n    }\n\n    @else if ($direction ==down) {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-top: $size solid $color;\n    }\n\n    @else {\n        border-left: $size solid transparent;\n        border-right: $size solid transparent;\n        border-bottom: $size solid $color;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
